import React from "react";
import { colors, gradients, transition } from "../theme";

const EpSessionActionsBar = ({
  selectedCount,
  totalCount,
  allSelected,
  onSelectAll,
  onToggleSelectAll,
  onValidateSelected,
  isClosed,
}) => {
  if (isClosed) return null;

  const hasSelection = selectedCount > 0;

  return (
    <div
      data-tour="actions-bar"
      className="d-flex justify-content-between align-items-center mb-3 px-3 py-2 rounded"
      style={{
        background: hasSelection
          ? "linear-gradient(135deg, #eff6ff, #dbeafe)"
          : colors.bg.page,
        border: hasSelection
          ? `1px solid ${colors.primary.light}`
          : `1px solid ${colors.border.default}`,
        transition,
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        {/* Checkbox tout sélectionner */}
        <label
          className="d-flex align-items-center mb-0"
          style={{ cursor: "pointer", gap: 8 }}
        >
          <input
            type="checkbox"
            checked={allSelected}
            onChange={onToggleSelectAll}
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
              accentColor: colors.primary.main,
            }}
          />
          <span
            style={{
              fontSize: 13,
              color: colors.text.secondary,
              fontWeight: 500,
            }}
          >
            Tout sélectionner
          </span>
        </label>

        {/* Separator */}
        <div
          style={{ width: 1, height: 20, background: colors.border.default }}
        />

        {/* Valider */}
        <button
          className="btn btn-sm"
          onClick={onValidateSelected}
          disabled={!hasSelection}
          style={{
            background: hasSelection
              ? gradients.success
              : colors.border.default,
            color: hasSelection ? colors.text.white : colors.text.muted,
            border: "none",
            borderRadius: 8,
            padding: "7px 16px",
            fontSize: 13,
            fontWeight: 700,
            boxShadow: hasSelection ? "0 2px 6px rgba(34,197,94,0.25)" : "none",
            transition,
          }}
        >
          <i className="fa fa-check mr-2" style={{ fontSize: 11 }} />
          Valider les propositions
        </button>
      </div>

      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        {hasSelection && (
          <div className="d-flex align-items-center" style={{ gap: 6 }}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: 22,
                height: 22,
                borderRadius: "50%",
                background: gradients.primary,
                color: colors.text.white,
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              {selectedCount}
            </div>
            <span
              style={{
                fontSize: 13,
                color: colors.primary.dark,
                fontWeight: 600,
              }}
            >
              sélectionné{selectedCount > 1 ? "s" : ""}
            </span>
            <div style={{ width: 1, height: 16, background: "#bfdbfe" }} />
          </div>
        )}
        <span style={{ fontSize: 13, color: colors.text.muted }}>
          {totalCount} allocataire{totalCount > 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
};

export default React.memo(EpSessionActionsBar);
